import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SELECTABLE_RECURRENCES } from "web_myplann/Reminders/Config/recurrenceLabels";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

export type SelectableRecurrence = (typeof SELECTABLE_RECURRENCES)[number];

export const useReminderRecurrenceOptions =
	(): FlatRowSelectOption<SelectableRecurrence>[] => {
		const { t } = useResource();

		return SELECTABLE_RECURRENCES.map((recurrence) => ({
			value: recurrence,
			label: t(Resources.Reminders.Recurrence[recurrence]),
		}));
	};
